import { render, staticRenderFns } from "./EditChannelName.vue?vue&type=template&id=0cb3fef7"
import script from "./EditChannelName.vue?vue&type=script&lang=js"
export * from "./EditChannelName.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports